'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _PageContainer = require('../PageContainer');

var _PageContainer2 = _interopRequireDefault(_PageContainer);

var _SurflineFooter = require('../SurflineFooter');

var _SurflineFooter2 = _interopRequireDefault(_SurflineFooter);

var _serviceConfigurationPropType = require('../PropTypes/serviceConfigurationPropType');

var _serviceConfigurationPropType2 = _interopRequireDefault(_serviceConfigurationPropType);

var _userPropType = require('../PropTypes/userPropType');

var _userPropType2 = _interopRequireDefault(_userPropType);

var _entitlementsPropType = require('../PropTypes/entitlementsPropType');

var _entitlementsPropType2 = _interopRequireDefault(_entitlementsPropType);

var _settingsPropType = require('../PropTypes/settingsPropType');

var _settingsPropType2 = _interopRequireDefault(_settingsPropType);

var _favoritesPropType = require('../PropTypes/favoritesPropType');

var _favoritesPropType2 = _interopRequireDefault(_favoritesPropType);

var _Notification = require('../Notification');

var _Notification2 = _interopRequireDefault(_Notification);

var _CTA = require('./CTA');

var _CTA2 = _interopRequireDefault(_CTA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurflinePageContainer = function (_Component) {
  (0, _inherits3.default)(SurflinePageContainer, _Component);

  function SurflinePageContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SurflinePageContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SurflinePageContainer.__proto__ || (0, _getPrototypeOf2.default)(SurflinePageContainer)).call.apply(_ref, [this].concat(args))), _this), _this.isPremium = function (entitlements) {
      return entitlements.indexOf('sl_premium') > -1;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SurflinePageContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var user = this.props.user;

      if (user && window && window.analytics) {
        window.analytics.identify(user._id);
      }
    }
  }, {
    key: 'dismissBannerHandler',
    value: function dismissBannerHandler() {
      _reactCookie2.default.save('dismissTimestamp', Date.now(), null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          user = _props.user,
          settings = _props.settings,
          favorites = _props.favorites,
          entitlements = _props.entitlements,
          showFooter = _props.showFooter,
          serviceConfig = _props.serviceConfig,
          largeFavoritesBar = _props.largeFavoritesBar;


      var largeNotification = void 0;
      var smallNotification = void 0;

      if (!this.isPremium(entitlements)) {
        var dismissDuration = 1000 * 60 * 60 * 24 * 8;
        var savedTimestamp = _reactCookie2.default.load('dismissTimestamp');
        var nextPresentationTime = savedTimestamp != null ? dismissDuration + parseInt(savedTimestamp, 10) : 0;

        largeNotification = nextPresentationTime < Date.now() ? _react2.default.createElement(
          _Notification2.default,
          {
            closable: true,
            type: 'large',
            level: 'information',
            onCloseComplete: this.dismissBannerHandler
          },
          _react2.default.createElement(
            _CTA2.default,
            { className: 'quiver-notification__tag-line', ctaLocation: 'upsell bar' },
            _react2.default.createElement(
              'span',
              { className: 'quiver-notification__tag-line__full-text' },
              'Ad-free Cams. Expert Forecast Analysis.'
            ),
            ' GO PREMIUM.'
          )
        ) : null;

        smallNotification = _react2.default.createElement(
          _Notification2.default,
          { type: 'small', level: 'information' },
          _react2.default.createElement(
            _CTA2.default,
            { className: 'quiver-notification__cta', ctaLocation: 'button top' },
            'GO PREMIUM'
          )
        );
      }

      var footer = void 0;
      if (showFooter) {
        footer = _react2.default.createElement(_SurflineFooter2.default, { entitlements: entitlements });
      }

      return _react2.default.createElement(
        _PageContainer2.default,
        {
          user: user,
          footer: footer,
          entitlements: entitlements,
          favorites: favorites,
          settings: settings,
          largeNotification: largeNotification,
          smallNotification: smallNotification,
          serviceConfig: serviceConfig,
          largeFavoritesBar: largeFavoritesBar
        },
        children
      );
    }
  }]);
  return SurflinePageContainer;
}(_react.Component);

SurflinePageContainer.propTypes = {
  children: _propTypes2.default.node,
  favorites: _favoritesPropType2.default,
  user: _userPropType2.default,
  entitlements: _entitlementsPropType2.default,
  showFooter: _propTypes2.default.bool,
  serviceConfig: _serviceConfigurationPropType2.default,
  settings: _settingsPropType2.default,
  largeFavoritesBar: _propTypes2.default.bool
};
SurflinePageContainer.defaultProps = {
  showFooter: true,
  user: null,
  settings: null,
  entitlements: [],
  children: _react2.default.createElement('div', null),
  serviceConfig: null,
  favorites: [],
  largeFavoritesBar: false
};
exports.default = SurflinePageContainer;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SurflinePageContainer/SurflinePageContainer.js
// module id = 673
// module chunks = 11